import React from "react";
import { Box, Button, Text, useThemeUI } from "theme-ui";
import { useSelector, useDispatch } from "react-redux";
import get from "lodash/fp/get";

import { useTranslation } from "hooks";
import { selectSelectedProduct, selectProductHeaderProps } from "store/app";
import { displayModal } from "store/app/appSlice";
import * as styles from "./Header.styles";
import { ChevronLeftIcon, CloseIcon, ForwardSlashIcon } from "components/icons";

export default function Header({
  goBackTo,
  appHeaderLogo,
  showLogoOnMobile = false,
  showSeparatorOnMobile = false,
}) {
  const { t } = useTranslation();
  const {
    theme: { isMobile },
  } = useThemeUI();
  const dispatch = useDispatch();

  const selectedProduct = useSelector(selectSelectedProduct);
  const { logo } = useSelector(selectProductHeaderProps);
  const { closeAppLink } = useSelector(get(["app", "formData"]));

  return (
    <Box sx={styles.headerContainer}>
      <Box sx={styles.headerContent}>
        {goBackTo && (
          <Button
            variant="unstyled"
            sx={styles.backButton}
            onClick={() => goBackTo()}
          >
            <ChevronLeftIcon stroke="white" />

            {!isMobile && (
              <Text variant="h5" sx={{ fontWeight: "300" }}>
                {t("go back")}
              </Text>
            )}
          </Button>
        )}

        {(!isMobile || showSeparatorOnMobile) && goBackTo && appHeaderLogo && (
          <Box sx={styles.separator} />
        )}

        {(!isMobile || showLogoOnMobile) && appHeaderLogo && (
          <Box
            as="img"
            src={appHeaderLogo.url}
            alt={appHeaderLogo?.alt}
            sx={styles.appLogo}
          />
        )}

        {!isMobile && (
          <>
            <ForwardSlashIcon sx={styles.forwardSlashSeparator} />
            {selectedProduct && (
              <Box
                as="img"
                src={logo.url}
                alt={logo?.alt}
                sx={styles.productFamilyLogo}
              />
            )}

            {!selectedProduct && (
              <Text variant="h5" sx={{ fontWeight: "300" }}>
                {t("custom goal gear")}
              </Text>
            )}
          </>
        )}
      </Box>

      <Box sx={styles.headerContent}>
        {selectedProduct && (
          <>
            {/* {isDesktop && (
              <Text variant="h5" sx={{ fontWeight: "300" }}>
                live chat
              </Text>
            )} */}
            {/* <LiveChatIcon /> */}
            {/* <Box sx={styles.separator2} />
            <Text variant="h4" sx={{ fontWeight: "300" }}>
              $10000
            </Text> */}
            {/* <Box sx={styles.separator2} /> */}
          </>
        )}

        <Button
          variant="unstyled"
          sx={styles.closeButton}
          onClick={
            selectedProduct
              ? () =>
                  dispatch(
                    displayModal({
                      modal: "LeaveAppModal",
                    })
                  )
              : () => (window.location.href = closeAppLink)
          }
        >
          <CloseIcon strokeWidth="10" stroke="#FFFFFF" />
        </Button>
        <Box sx={styles.separator2} />
      </Box>
    </Box>
  );
}
